import { useMemo } from 'react';
import { Navigate } from 'react-router';
import {
  AuthenticatedNotFound,
  CommunityAboutPage,
  PageCommunityAbout,
  PageCommunityFeed,
  PageEventDetail,
  PageGivingDetail,
  PageKudos,
  PagePost,
  PagePublicCommunityAbout,
  PagePublicEvent,
  PagePublicGiving,
  PagePublicKudos,
  PagePublicPost,
  PagePublicSharedEvent,
  PreconditionFailedGuard,
  TimezoneConfirmationGuard,
} from 'pages';
import { routes } from '../../routes';
import { SplitAuthenticationGuard } from '../split-authentication-guard';

export const useCommonWebRouter = () =>
  useMemo(
    () => [
      {
        children: [
          {
            children: [
              {
                element: (
                  <SplitAuthenticationGuard
                    authenticated={<PageEventDetail />}
                    notAuthenticated={<PagePublicEvent />}
                  />
                ),
                path: routes.events.detail(':eventId'),
              },
              {
                element: (
                  <SplitAuthenticationGuard
                    authenticated={<PageGivingDetail />}
                    notAuthenticated={<PagePublicGiving />}
                  />
                ),
                path: routes.giving.detail(':givingId'),
              },
              {
                element: (
                  <SplitAuthenticationGuard authenticated={<PagePost />} notAuthenticated={<PagePublicPost />} />
                ),
                path: '/posts/:postId/comments?/:commentId?/:replyId?',
              },
              {
                element: (
                  <SplitAuthenticationGuard authenticated={<PageKudos />} notAuthenticated={<PagePublicKudos />} />
                ),
                path: '/kudos/:kudosId/comments?/:commentId?/:replyId?',
              },
              {
                element: (
                  <SplitAuthenticationGuard
                    authenticated={<CommunityAboutPage />}
                    notAuthenticated={<PagePublicCommunityAbout />}
                  />
                ),
                path: routes.community.new.about(':communityId'),
              },
              {
                element: (
                  <SplitAuthenticationGuard
                    authenticated={<PageCommunityAbout />}
                    notAuthenticated={<PagePublicCommunityAbout />}
                  />
                ),
                path: '/communities/:communityId/about',
              },
              {
                element: (
                  <SplitAuthenticationGuard
                    authenticated={<PageCommunityFeed />}
                    notAuthenticated={
                      <Navigate
                        replace
                        // TODO: This maybe not work now correctly
                        state={{ referrer: `${window.location.pathname}${window.location.search}` }}
                        to={routes.signUp}
                      />
                    }
                  />
                ),
                path: '/communities/:communityId',
              },
              {
                element: <PagePublicSharedEvent />,
                path: routes.events.share(':eventId', ':invitationToken'),
              },
            ],
            element: <TimezoneConfirmationGuard />,
          },
          {
            element: (
              <SplitAuthenticationGuard
                authenticated={<AuthenticatedNotFound />}
                // TODO: Not sure if here works remember original location now
                notAuthenticated={<Navigate replace to="/login" />}
              />
            ),
            path: '/*',
          },
        ],
        element: <PreconditionFailedGuard />,
      },
    ],
    [],
  );
